import React from "react";
import RefundRequestsItems from "../RefundRequests/RefundRequestsItems/RefundRequestsItems";

const RefundRequestsItemsSupplier = (props) => (
  <RefundRequestsItems
    {...props}
    backPath="/admin/refund-requests-supplier"
    companyType="seller"
  />
);

export default RefundRequestsItemsSupplier;
